import { defineMessages } from 'react-intl-next';

/**
 * Copy is intentionally `.non-final` until the NCS team finalizes the wording;
 * finalizing removes the suffix and triggers translation.
 */
export const messages = defineMessages({
  'whiteboards.ncs-announcement-banner.body.non-final': {
    id: 'whiteboards.ncs-announcement-banner.body.non-final',
    defaultMessage:
      'We’re dogfooding a major refactor of the collaboration architecture. If anything doesn’t look right, please let us know in <link>#whiteboards-ncs-feedback</link>',
    description:
      'Announcement banner shown during the NCS refactor rollout, inviting users to contact the team via Slack if they hit issues. <link> wraps the Slack channel link.',
  },
  'whiteboards.ncs-announcement-banner.dismiss.non-final': {
    id: 'whiteboards.ncs-announcement-banner.dismiss.non-final',
    defaultMessage: 'Dismiss announcement',
    description:
      'Accessible label for the button that dismisses the NCS refactor announcement banner.',
  },
});
